// FAQ screenshots per locale; locales with no screenshot fall back to English.
import type { LocalizedImageMap } from '../../utils';

import completionCertificateEs from './completion-certificate-es.png';
import completionCertificateFr from './completion-certificate-fr.png';
import completionCertificateHi from './completion-certificate-hi.png';
import completionCertificateSw from './completion-certificate-sw.png';
import completionCertificateZh from './completion-certificate-zh.png';
import completionCertificateEn from './completion-certificate.png';
import courseContentBannerFr from './course-content-banner-fr.png';
import courseContentBannerEn from './course-content-banner.png';
import courseContentCoreCommitmentsFr from './course-content-core-commitments-fr.png';
import courseContentCoreCommitmentsEn from './course-content-core-commitments.png';
import editProfileEs from './edit-profile-es.png';
import editProfileFr from './edit-profile-fr.png';
import editProfileHi from './edit-profile-hi.png';
import editProfileSw from './edit-profile-sw.png';
import editProfileZh from './edit-profile-zh.png';
import editProfileEn from './edit-profile.png';
import forgotPasswordEs from './forget-password-es.jpg';
import forgotPasswordFr from './forget-password-fr.jpg';
import forgotPasswordHi from './forget-password-hi.jpg';
import forgotPasswordSw from './forget-password-sw.jpg';
import forgotPasswordZh from './forget-password-zh.jpg';
import forgotPasswordEn from './forget-password.jpg';
import introductionCourseContentFr from './introduction-course-content-fr.png';
import introductionCourseContentEn from './introduction-course-content.png';
import profileCertificatesEs from './profile-certificates-es.png';
import profileCertificatesFr from './profile-certificates-fr.png';
import profileCertificatesHi from './profile-certificates-hi.png';
import profileCertificatesSw from './profile-certificates-sw.png';
import profileCertificatesZh from './profile-certificates-zh.png';
import profileCertificatesEn from './profile-certificates.png';
import registerAccountEs from './register-account-es.jpg';
import registerAccountFr from './register-account-fr.jpg';
import registerAccountHi from './register-account-hi.jpg';
import registerAccountSw from './register-account-sw.jpg';
import registerAccountZh from './register-account-zh.jpg';
import registerAccountEn from './register-account.jpg';
import signupAccount2Es from './signup-account-2-es.jpg';
import signupAccount2Fr from './signup-account-2-fr.jpg';
import signupAccount2Hi from './signup-account-2-hi.jpg';
import signupAccount2Sw from './signup-account-2-sw.jpg';
import signupAccount2Zh from './signup-account-2-zh.jpg';
import signupAccount2En from './signup-account-2.jpg';
import signupAccountEs from './signup-account-es.jpg';
import signupAccountFr from './signup-account-fr.jpg';
import signupAccountHi from './signup-account-hi.jpg';
import signupAccountSw from './signup-account-sw.jpg';
import signupAccountZh from './signup-account-zh.jpg';
import signupAccountEn from './signup-account.jpg';

export const registerAccountImages: LocalizedImageMap = {
  en: registerAccountEn,
  'es-419': registerAccountEs,
  fr: registerAccountFr,
  hi: registerAccountHi,
  sw: registerAccountSw,
  'zh-cn': registerAccountZh,
};
export const signupAccountImages: LocalizedImageMap = {
  en: signupAccountEn,
  'es-419': signupAccountEs,
  fr: signupAccountFr,
  hi: signupAccountHi,
  sw: signupAccountSw,
  'zh-cn': signupAccountZh,
};
export const signupAccount2Images: LocalizedImageMap = {
  en: signupAccount2En,
  'es-419': signupAccount2Es,
  fr: signupAccount2Fr,
  hi: signupAccount2Hi,
  sw: signupAccount2Sw,
  'zh-cn': signupAccount2Zh,
};
export const forgotPasswordImages: LocalizedImageMap = {
  en: forgotPasswordEn,
  'es-419': forgotPasswordEs,
  fr: forgotPasswordFr,
  hi: forgotPasswordHi,
  sw: forgotPasswordSw,
  'zh-cn': forgotPasswordZh,
};
export const introductionCourseContentImages: LocalizedImageMap = {
  en: introductionCourseContentEn,
  fr: introductionCourseContentFr,
};
export const courseContentCoreCommitmentsImages: LocalizedImageMap = {
  en: courseContentCoreCommitmentsEn,
  fr: courseContentCoreCommitmentsFr,
};
export const courseContentBannerImages: LocalizedImageMap = {
  en: courseContentBannerEn,
  fr: courseContentBannerFr,
};
export const completionCertificateImages: LocalizedImageMap = {
  en: completionCertificateEn,
  'es-419': completionCertificateEs,
  fr: completionCertificateFr,
  hi: completionCertificateHi,
  sw: completionCertificateSw,
  'zh-cn': completionCertificateZh,
};
export const profileCertificatesImages: LocalizedImageMap = {
  en: profileCertificatesEn,
  'es-419': profileCertificatesEs,
  fr: profileCertificatesFr,
  hi: profileCertificatesHi,
  sw: profileCertificatesSw,
  'zh-cn': profileCertificatesZh,
};
export const editProfileImages: LocalizedImageMap = {
  en: editProfileEn,
  'es-419': editProfileEs,
  fr: editProfileFr,
  hi: editProfileHi,
  sw: editProfileSw,
  'zh-cn': editProfileZh,
};
